import React, { useState, useEffect } from 'react';
import TestimonialItem from "../../../Items/TestimonialItem";
import noImage from "../../../../assets/image/male-placeholder-image.jpeg"
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import "animate.css";

import { postData } from '../../../../services/api';
import { useTranslation } from "react-i18next";

const ClientTestimonials = () => {
  const { i18n, t } = useTranslation();
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadList = async () => {
      try {
        setLoading(true);
        const result = await postData("/testimonial/list", {
          sortQuery: { created_at: 1 },
          status: 1,
        });
        
        if (result.data) {
          setTestimonials(
            result.data.sort((a, b) => a.ordering - b.ordering).map((item, index) => {
              return {
                id: item.id || index,
                name: item?.name?.[i18n?.language],
                designation: item?.company?.[i18n?.language],
                image: noImage,
                description: item?.comments?.[i18n?.language],
              }
            })
          );
        }
      } catch (error) {
        console.error('Error loading testimonials:', error);
      } finally {
        setLoading(false);
      }
    };
    
    loadList();
  }, [i18n?.language]);

  const TestimonialData = {
    title: t('What_do_our_clients_say'),
    Testimonial: testimonials
  }

  if (loading) {
    return (
      <section className="relative w-full py-16 bg-white" id="testimonial-section">
        <div className="w-full px-4 sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl mx-auto">
          <div className="max-w-3xl w-full mx-auto text-center mb-12">
            <div className="h-8 bg-gray-200 rounded-lg animate-pulse mb-6"></div>
            <div className="h-4 bg-gray-200 rounded-lg animate-pulse max-w-2xl mx-auto"></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 lg:gap-8">
            {[...Array(6)].map((_, index) => (
              <div key={index} className="bg-gray-200 rounded-xl h-96 animate-pulse"></div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="relative w-full py-16 bg-white" id="testimonial-section">
      <div className="w-full px-4 sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl mx-auto">
        
        {/* Enhanced Header */}
        <div className="max-w-4xl w-full mx-auto text-center mb-12 xl:mb-16">
          <div className="inline-block mb-6">
            <span className="bg-[#F4F7FA] text-dark-teal-700 px-4 py-2 rounded-full text-sm font-medium font-Inter">
              Client Success Stories
            </span>
          </div>
          
          <h2 
            className="capitalize text-slate-950 text-3xl xs:text-4xl !leading-tight lg:text-5xl xl:text-6xl font-extrabold font-PlusJakartaSans mb-6" 
            dangerouslySetInnerHTML={{ __html: TestimonialData.title }}
          />
          
          <p className="text-slate-700 font-Inter text-lg leading-relaxed max-w-2xl mx-auto">
            {t('testimonial_subtitle', 'Don\'t just take our word for it. Here\'s what our clients are saying about their experience.')}
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 lg:gap-8">
          {TestimonialData.Testimonial.map((item, index) => (
            <div 
              key={item?.id || index} 
              className="animate__animated animate__fadeInUp"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <TestimonialItem data={item} />
            </div>
          ))}
        </div>        

        {/* Empty state */}
        {TestimonialData.Testimonial.length === 0 && !loading && (
          <div className="text-center py-16">
            <div className="text-slate-400 text-lg font-Inter">
              {t('no_testimonials', 'No testimonials available at the moment.')}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default ClientTestimonials;